import { useEffect, useState } from "react";
import { animate } from "framer-motion";

interface Props {
  value: number;
  className?: string;
  prefix?: string;
  duration?: number;
}

/**
 * Counts up from 0 to `value` over `duration` seconds.
 * Renders the integer dollar amount with thousands separators.
 */
export default function AnimatedTotal({ value, className, prefix = "$", duration = 1.2 }: Props) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const controls = animate(0, value, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [value, duration]);

  return (
    <span className={className}>
      {prefix}
      {display.toLocaleString()}
    </span>
  );
}